import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import useOrderLeadTime from '@hooks/useOrderLeadTime'

const OrderLeadTime = (props) => {
  const { callbacks: { confirmDelete }, orderLeadTime: initLeadTime } = props

  const orderLeadTimePayload = useOrderLeadTime(initLeadTime)

  const {
    callbacks: { createOrEditOrderLeadTime, deleteOrderLeadTime: deleteFn },
    leadTimeText,
    orderLeadTime: { unit },
    serviceProduct,
  } = orderLeadTimePayload

  return (
    <DashboardModuleListItem
      title={(
        <Box alignItems="center">
          <Box color="faintGrey" marginRight="medium" width="fit-content">
            <FontAwesomeIcon icon={faAngleRight} />
          </Box>
          {serviceProduct.title}
        </Box>
      )}
    >
      {!!unit && (
        <DashboardModuleListItem.TertiaryText>
          {leadTimeText}
        </DashboardModuleListItem.TertiaryText>
      )}

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditOrderLeadTime()}
          type="edit"
        />

        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteFn)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

OrderLeadTime.propTypes = {
  callbacks: PropTypes.shape({
    confirmDelete: PropTypes.func.isRequired,
  }).isRequired,
  orderLeadTime: PropTypes.object.isRequired,
}

export default OrderLeadTime
